import React, { Component } from 'react';
import {Modal, Button,Tabs,Tab,ButtonToolbar,OverlayTrigger,Tooltip} from 'react-bootstrap';
import Scrollbar from 'react-scrollbars-custom';
import {connect} from 'react-redux';
import { TextField } from '@rmwc/textfield';
import { Select } from '@rmwc/select';
import * as actionCreator from "../../action/index.js"
import Buildingimage from '../../assets/images/banner_img.png';
import CommonPromptBox from "./CommonPromptBox";
const baseUrl = process.env.REACT_APP_BASE_URL;

class LayoutDesign extends React.Component {

constructor(props) {
  super(props);

   this.state = {
      showModal: false,
    
    };
}


showModal=(e)=>{
  this.setState({ showModal: true });
  e.stopPropagation();
}

closeModal = () => {
  this.setState({showModal: false});
}

render() {


    return (
       <div>
           <Modal centered show={this.props.const_var.isLayoutDesign} backdrop='static' keyboard={false} onHide={(e)=>this.props.isOpenLayoutDesignModal(false,"actionclose")} dialogClassName="designlayoutbuilding-modal react-modal"   backdropClassName="ract-modal-pre-parent designlayoutparent visiblestatescreen-modal" >              
         
            <Modal.Body >                  
              <div className="layout-wrapper">
                <div className="design-layout-top">
                      <h5 class="modal-title ">Welcome back to Sensei 3D Designer</h5>
                 <h6><span className="icon icon-show-buildings-arrow"></span>You can Load an Existing Building<span className="icon icon-arrow-thin"></span><span className="or">or</span> <a onClick={(e)=>this.props.isOpenLayoutDesignModal(false,"actionclose")}><span className="text">Create a New Building</span><span className="icon icon-arrow-thin"></span></a></h6>
                 </div>
                
                  <div className="design-layout-bottom">
                      <div className="row"> 
                          <div className="col-lg-4 col-md-6 layoutbuild-sec"> 
                              <div className="layoutbuild-sec-inner">
                               
                                     <div className="layoutbuild-sec-inner-box">
                                    
                                        <div className="layout-image">
                                          <a onClick={(e)=> this.showModal(e)} className="delete-layout-design"><span className="icon icon-delete"></span></a>
                                          <img src={baseUrl+Buildingimage} className="img-fluid" alt=""/>
                                         </div>

                                         <div className="layout-design-content"> 
                                          <h4>Standard Garages - 24 x 40 x 10</h4>
                                          <h6>Building edited 20 mins ago</h6>
                                          <div className="design-layout-pick-cta">
                                              <a className="btn-round with-bg-left-to-right"><span className="icon icon-content"></span><span className="text">PICK THIS BUILDING</span></a>
                                          </div>
                                         </div>
                                     </div>
                              </div>
                          </div>
                               <div className="col-lg-4 col-md-6 layoutbuild-sec"> 
                              <div className="layoutbuild-sec-inner">
                               
                                     <div className="layoutbuild-sec-inner-box">
                                    
                                        <div className="layout-image">
                                          <a onClick={(e)=> this.showModal(e)} className="delete-layout-design"><span className="icon icon-delete"></span></a>
                                          <img src={baseUrl+Buildingimage} className="img-fluid" alt=""/>
                                         </div>

                                         <div className="layout-design-content"> 
                                          <h4>Standard Garages - 24 x 40 x 10</h4>
                                          <h6>Building edited 20 mins ago</h6>
                                          <div className="design-layout-pick-cta">
                                              <a className="btn-round with-bg-left-to-right"><span className="icon icon-content"></span><span className="text">PICK THIS BUILDING</span></a>
                                          </div>
                                         </div>
                                     </div>
                              </div>
                          </div>
                               <div className="col-lg-4 col-md-6 layoutbuild-sec"> 
                              <div className="layoutbuild-sec-inner">
                               
                                     <div className="layoutbuild-sec-inner-box">                                    
                                        <div className="layout-image">
                                          <a onClick={(e)=> this.showModal(e)} className="delete-layout-design"><span className="icon icon-delete"></span></a>
                                          <img src={baseUrl+Buildingimage} className="img-fluid" alt=""/>
                                         </div>

                                         <div className="layout-design-content"> 
                                          <h4>Standard Garages - 24 x 40 x 10</h4>
                                          <h6>Building edited 20 mins ago</h6>
                                          <div className="design-layout-pick-cta">
                                              <a className="btn-round with-bg-left-to-right"><span className="icon icon-content"></span><span className="text">PICK THIS BUILDING</span></a>
                                          </div>
                                         </div>
                                     </div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <CommonPromptBox show={this.state.showModal} handleClose={this.closeModal} message="This action will delete your building. Are you sure you want to delete this building?" alerttitle="CONFIRM DELETE" withtwoaction="true"  backdropclass="visiblestatescreen-modal forextrabg" imagedelete={baseUrl+Buildingimage} />
               </div>
                                 
             </Modal.Body>
          
                 
        </Modal>
        </div>
    )
  }
}

const mapStoreToProps = (state) => {
  return state.reducer
}


export default connect(
  mapStoreToProps,
  actionCreator
)(LayoutDesign);